module.exports = __webpack_public_path__ + "img/ic-diamond-black.ffcd2061.svg";